const mutations = {
  SET_NOTIFICATIONS (state, { notifications }) {
    state.notifications = notifications
  }
}

export default mutations
